import React from 'react'
import ShareMenu from './ShareMenu'
import Footer from './Footer'
import '../App.css'

export default function Wine({
        isJustLoaded,
        shouldRender,
        menuOpen,
        theme,
        setMenuOpen,
        darkColor,
        fontMapBold,
        headerText,
        wineData,
        fontMapReg,
        bodyText,
        imageBase,
        imageType,
        wineryLogo,
        matches,
        tastingText,
        userFlavorData,
        userAcidity,
        barColor,
        userSweetness,
        lightColor,
        wineProfileData,
        wineFlavors,
        qrData,
        iconQRIMGID,
        QR,
        Share,
        wineAcidity,
        wineSweetness,
        beerData
}) {
  return (
    <div>
        <div className={`top-div ${isJustLoaded ? 'invisible' : 'fade-in'}`}>
         <div className='mobile-container'>
            {shouldRender && (
             <ShareMenu
               menuOpen={menuOpen}
               theme={theme}
               setMenuOpen={setMenuOpen}
             />
           )}
           <div className='wine-title-div' style={{ backgroundColor: darkColor[theme] }}>
             <h1 className='wine-title' style={{ fontFamily: fontMapBold[headerText] }}>{wineData?.data?.name}</h1>
             <p className="year" style={{ fontFamily: fontMapReg[bodyText] }}>{wineData?.data?.year}</p>
           </div>
           <div className='big-wine-container'>
             <img className='wine-image' src={`${imageBase}${wineData?.data?.bottle_image}${imageType}`} alt="Wine bottle" />
             <img src={`${imageBase}${wineryLogo}${imageType}`} className='wine-logo'></img>
           </div>
           <div className='content-div'>
             <div className='right-col'>
               <div className='top-right' style={{ backgroundColor: darkColor[theme] }}>
                 <h2 className='my-profile-header' style={{ fontFamily: fontMapBold[headerText] }}>My Tasting Profile</h2>
                 <p className="user-profile" style={{ fontFamily: fontMapReg[bodyText] }}>
                   {matches === null || matches === 0 ? tastingText.no_match_text : matches === 1 || matches === 2 ? tastingText.low_match_text
                     : tastingText.high_match_text}
                 </p>
                 <h3 className='flavors-header' style={{ fontFamily: fontMapBold[headerText] }}>Flavors</h3>
                 <div>
                   <div className='flavors-container top'>
                     {userFlavorData?.data?.slice(0, 3).map(item => (
                       <div className='flavor-box' >
                         <div className='flav-img-container' style={{ backgroundColor: item.highlight_color }}>
                           <img
                             className='user-flavor-img'
                             key={item.id}
                             src={`${imageBase}${item.image}${imageType}`}
                             alt={`Flavor ${item.Flavors_id}`}
                           />
                         </div>
                         <p className='flavor-title' style={{ fontFamily: fontMapReg[bodyText] }}>{item.name}</p>
                       </div>
                     ))}
                   </div>
                   {userFlavorData?.data?.length > 3 && (
                     <div className='flavors-container bottom'>
                       {userFlavorData?.data?.slice(3, 5).map(item => (
                         <div className='flavor-box' key={item.id}>
                           <div className='flav-img-container' style={{ backgroundColor: item.highlight_color }}>
                             <img
                               className='user-flavor-img'
                               src={`${imageBase}${item.image}${imageType}`}
                               alt={`Flavor ${item.Flavors_id}`}
                             />
                           </div>
                           <p className='flavor-title' style={{ fontFamily: fontMapReg[bodyText] }}>{item.name}</p>
                         </div>
                       ))}
                     </div>
                   )}
                 </div>
                 <div className='acid-sweetness-columns'>
                   <div className='acidity-col'>
                     <h4 className='acidity-header' style={{ fontFamily: fontMapBold[bodyText] }}>Acidity</h4>
                     <div className='acidity-bar'>
                       <div style={{
                         height: '55%',
                         width: `${userAcidity}%`,
                         backgroundColor: barColor[theme],
                         borderRadius: '15vw',
                         marginLeft: '3.5%',
                         marginRight: '3.5%'
                       }}>
                       </div>
                     </div>
                     <div className='acid-label-columns'>
                       <div className='l-acid-col'>
                         <p className='low-lable' style={{ fontFamily: fontMapReg[bodyText] }}>Low</p>
                       </div>
                       <div className='r-acid-col'>
                         <p className='high-lable' style={{ fontFamily: fontMapReg[bodyText] }}>High</p>
                       </div>
                     </div>
                   </div>
                   <div className='sweetness-col'>
                     <h4 className='acidity-header' style={{ fontFamily: fontMapBold[bodyText] }}>Sweetness</h4>
                     <div className='sweetness-bar'>
                       <div style={{
                         height: '55%',
                         width: `${userSweetness}%`,
                         backgroundColor: barColor[theme],
                         borderRadius: '15vw',
                         marginLeft: '3%',
                         marginRight: '3%'
                       }}>
                       </div>
                     </div>
                     <div className='acid-label-columns'>
                       <div className='l-acid-col'>
                         <p className='low-lable' style={{ fontFamily: fontMapReg[bodyText] }}>Dry</p>
                       </div>
                       <div className='r-acid-col'>
                         <p className='high-lable' style={{ fontFamily: fontMapReg[bodyText] }}>Very Sweet</p>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>


               {/* Wine Profile Section - Mobile */}
               <div className='bottom-right' style={{ backgroundColor: lightColor[theme] }}>
                 <h2 className='my-profile-header' style={{ fontFamily: fontMapBold[bodyText] }}>{wineData?.data?.name} Profile</h2>
                 <p className="user-profile" style={{ fontFamily: fontMapReg[bodyText] }}>{wineProfileData?.data?.description}</p>
                 <h3 className='flavors-header' style={{ fontFamily: fontMapBold[bodyText] }}>Flavors</h3>
                 <div>
                   <div className='flavors-container top'>
                     {wineFlavors?.data?.slice(0, 3).map(item => (
                       <div className='flavor-box' >
                         <div className='flav-img-container' style={{ backgroundColor: item.highlight_color }}>
                           <img
                             className='user-flavor-img'
                             key={item.id}
                             src={`${imageBase}${item.image}${imageType}`}
                             alt={`Flavor ${item.Flavors_id}`}
                           />
                         </div>
                         <p className='flavor-title'>{item.name}</p>
                       </div>
                     ))}
                   </div>
                   {wineFlavors?.data?.length > 3 && (
                     <div className='flavors-container bottom'>
                       {wineFlavors?.data?.slice(3, 5).map(item => (
                         <div className='flavor-box' key={item.id}>
                           <div className='flav-img-container' style={{ backgroundColor: item.highlight_color }}>
                             <img
                               className='user-flavor-img'
                               src={`${imageBase}${item.image}${imageType}`}
                               alt={`Flavor ${item.Flavors_id}`}
                             />
                           </div>
                           <p className='flavor-title'>{item.name}</p>
                         </div>
                       ))}
                     </div>
                   )}
                   <div className='acid-sweetness-columns'>
                     <div className='acidity-col'>
                       <h4 className='acidity-header' style={{ fontFamily: fontMapBold[headerText] }}>Acidity</h4>
                       <div className='acidity-bar'>
                         <div style={{
                           height: '55%',
                           width: `${wineAcidity}%`,
                           backgroundColor: barColor[theme],
                           borderRadius: '15vw',
                           marginLeft: '3%',
                           marginRight: '3%'
                         }}>
                         </div>
                       </div>
                       <div className='acid-label-columns'>
                         <div className='l-acid-col'>
                           <p className='low-lable' style={{ fontFamily: fontMapReg[headerText] }}>Low</p>
                         </div>
                         <div className='r-acid-col'>
                           <p className='high-lable' style={{ fontFamily: fontMapReg[headerText] }}>High</p>
                         </div>
                       </div>
                     </div>
                     <div className='sweetness-col'>
                       <h4 className='acidity-header' style={{ fontFamily: fontMapBold[headerText] }}>Sweetness</h4>
                       <div className='sweetness-bar'>
                         <div style={{
                           height: '55%',
                           width: `${wineSweetness}%`,
                           backgroundColor: barColor[theme],
                           borderRadius: '15vw',
                           marginLeft: '2%',
                         }}>
                         </div>
                       </div>
                       <div className='acid-label-columns'>
                         <div className='l-acid-col'>
                           <p className='low-lable' style={{ fontFamily: fontMapReg[headerText] }}>Dry</p>
                         </div>
                         <div className='r-acid-col'>
                           <p className='high-lable' style={{ fontFamily: fontMapReg[headerText] }}>Very Sweet</p>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
               <div className='qr-code-section' style={{ backgroundColor: lightColor[theme] }} >
                 <button className='share-link' onClick={() => setMenuOpen(true)}>
                   <img className='share-img' alt='share-icon' src={Share}></img>
                   <p className='share-lable' style={{ fontFamily: fontMapReg[headerText] }}>Share your <br />Experience</p>
                 </button>


                 {qrData?.data?.map((item, index) => {
                   const iconId = iconQRIMGID?.[index]; // Get the corresponding image ID

                   const imageSrc = iconId && String(iconId).length >= 3
                      ? `${process.env.REACT_APP_IMAGE_ENDPOINT}${iconId}${process.env.REACT_APP_IMAGE_TYPE}`: QR;

                   return (
                     <button
                       className='share-link'
                       key={item.id}
                       onClick={() => window.open(item.url, '_blank', 'noopener,noreferrer')}
                     >
                       <img
                         className='share-img'
                         src={imageSrc}
                         alt={`Flavor ${item.Flavors_id}`}
                       />
                       <p className='share-lable'>{item.label}</p>
                     </button>
                   );
                 })}
               </div>     
             </div>
           </div>
         </div>

         {/* Desktop */}
         <div className={`desktop-container ${isJustLoaded ? 'invisible' : 'fade-in'}`}>
           <div className='large-wine-container'>
             <img className='wine-img' alt='Wine Bottle' src={`${imageBase}${wineData?.data?.bottle_image}${imageType}`}></img>
           </div>
           <div className='header' style={{ backgroundColor: darkColor[theme] }}>
             <div className='qr-code-section'>
               <button
                 onClick={() => setMenuOpen(true)}
                 className='share-link'
               >
                 <img className='share-img' alt='share-icon' src={Share}></img>
                 <p className='share-lable'>Share your <br />Experience</p>
               </button>
               {qrData?.data?.map((item, index) => {
                 const iconId = iconQRIMGID?.[index]; // Get the corresponding image ID


                 const imageSrc = iconId && String(iconId).length >= 3
                  ? `${process.env.REACT_APP_IMAGE_ENDPOINT}${iconId}${process.env.REACT_APP_IMAGE_TYPE}`
  : QR;



                 return (
                   <button
                     className='share-link'
                     key={item.id}
                     onClick={() => window.open(item.url, '_blank', 'noopener,noreferrer')}
                   >
                     <img
                       className='share-img'
                       src={imageSrc}
                       alt={`Flavor ${item.Flavors_id}`}
                     />
                     <p className='share-lable'>{item.label}</p>
                   </button>
                 );
               })}
             </div>
             <div className='logo-desk-container'>
               <img
                 src={`${imageBase}${wineryLogo}${imageType}`}
                 className='wine-logo'
                 alt='Winery Logo'
                 style={{
                   marginTop: (
                     wineryLogo === "f0c689f4-c1db-4791-b400-f609c42c61b5" ||
                     wineryLogo === "e3cf9955-ad3e-4261-bbf0-ba0f4f3a34ef"
                   ) ? "-14%" : (
                     wineryLogo === "9bb5ff3a-b4f5-40cc-8fa1-c5340ec1b77a" ? "3%" : "0"
                   )
                 }}
               ></img>
             </div>
           </div>
           {shouldRender && (
             <ShareMenu
               menuOpen={menuOpen}
               theme={theme}
               setMenuOpen={setMenuOpen}
             />
           )}
           <div className='content' style={{ backgroundColor: lightColor[theme] }}>
             <div className='name-div'>
               <h1 className='wine-title'>{wineData?.data?.name} <span className='wine-year'>{wineData?.data?.year}</span></h1>
             </div>
             <div className='flavor-columns'>
               <div className='l-col'>
                 <div className='profile-container'>
                   <h2 className='my-profile-header'>My Tasting Profile</h2>
                   <p className="user-profile">
                     {matches === null || matches === 0 ? tastingText.no_match_text : matches === 1 || matches === 2 ? tastingText.low_match_text
                       : tastingText.high_match_text}
                   </p>
                 </div>
                 <h3 className='flavors-header'>Flavors</h3>
                 <div>
                   <div className='flavors-container top'>
                     {userFlavorData?.data?.map(item => (
                       <div className='flavor-box' >
                         <div className='flav-img-container' style={{ backgroundColor: item.highlight_color }}>
                           <img
                             className='user-flavor-img'
                             key={item.id}
                             src={`${imageBase}${item.image}${imageType}`}
                             alt={`Flavor ${item.Flavors_id}`}
                           />
                         </div>
                         <p className='flavor-title'>{item.name}</p>
                       </div>
                     ))}
                   </div>
                   <div className='acid-sweetness-columns'>
                     <div className='acidity-col'>
                       <h4 className='acidity-header'>Acidity</h4>
                       <div className='acidity-bar'>
                         <div style={{
                           height: '65%',
                           width: `${userAcidity}%`,
                           backgroundColor: barColor[theme],
                           borderRadius: '15vw',
                           marginLeft: '2%',
                           marginRight: '2%',
                         }}>
                         </div>
                       </div>
                       <div className='acid-label-columns'>
                         <div className='l-acid-col'>
                           <p className='low-lable'>Low</p>
                         </div>
                         <div className='r-acid-col'>
                           <p className='high-lable'>High</p>
                         </div>
                       </div>
                     </div>
                     <div className='sweetness-col'>
                       <h4 className='acidity-header'>Sweetness</h4>
                       <div className='sweetness-bar'>
                         <div style={{
                           height: '65%',
                           width: `${userSweetness}%`,
                           backgroundColor: barColor[theme],
                           borderRadius: '15vw',
                           marginLeft: '2%',
                           marginRight: '2%'
                         }}>
                         </div>
                       </div>
                       <div className='acid-label-columns'>
                         <div className='l-acid-col'>
                           <p className='low-lable'>Dry</p>
                         </div>
                         <div className='r-acid-col'>
                           <p className='high-lable'>Very Sweet</p>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
               <div className='r-col'>
                 <div className='profile-container'>
                   <h2 className='my-profile-header'>{wineData?.data?.name} Profile</h2>
                   <p className="user-profile">{wineProfileData?.data?.description}</p>
                 </div>
                 <h3 className='flavors-header'>Flavors</h3>
                 <div>
                   <div className='flavors-container top'>
                     {wineFlavors?.data?.map(item => (
                       <div className='flavor-box' >
                         <div className='flav-img-container' style={{ backgroundColor: item.highlight_color }}>
                           <img
                             className='user-flavor-img'
                             key={item.id}
                             src={`${imageBase}${item.image}${imageType}`}
                             alt={`Flavor ${item.Flavors_id}`}
                           />
                         </div>
                         <p className='flavor-title'>{item.name}</p>
                       </div>
                     ))}
                   </div>
                 </div>
                 <div className='acid-sweetness-columns'>
                   <div className='acidity-col'>
                     <h4 className='acidity-header'>Acidity</h4>
                     <div className='acidity-bar'>
                       <div style={{
                         height: '65%',
                         width: `${wineAcidity}%`,
                         backgroundColor: barColor[theme],
                         borderRadius: '15vw',
                         marginLeft: '2%',
                         marginRight: '2%'
                       }}>
                       </div>
                     </div>
                     <div className='acid-label-columns'>
                       <div className='l-acid-col'>
                         <p className='low-lable'>Low</p>
                       </div>
                       <div className='r-acid-col'>
                         <p className='high-lable'>High</p>
                       </div>
                     </div>
                   </div>
                   <div className='sweetness-col'>
                     <h4 className='acidity-header'>Sweetness</h4>
                     <div className='sweetness-bar'>
                       <div style={{
                         height: '65%',
                         width: `${wineSweetness}%`,
                         backgroundColor: barColor[theme],
                         borderRadius: '15vw',
                         marginLeft: '2%',
                         marginRight: '2%'
                       }}>
                       </div>
                     </div>
                     <div className='acid-label-columns'>
                       <div className='l-acid-col'>
                         <p className='low-lable'>Dry</p>
                       </div>
                       <div className='r-acid-col'>
                         <p className='high-lable'>Very Sweet</p>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
           </div>
         </div>
       </div>
    </div>
  )
}
